<div
  #el
  class="ws-collapse"
  [ngClass]="{
    'overflow-ellipsis': true,
    'cursor-help': el.scrollWidth > el.clientWidth && showHelpCursor
  }"
  matTooltip="{{ el.innerText }}"
  [matTooltipDisabled]="!(el.scrollWidth > el.clientWidth)"
>
  <ng-content></ng-content>
</div>
